export default __webpack_public_path__ + "static/media/IconDesc_Rotor.256.555ad0ed.png";